import script from "./RcdView.vue?vue&type=script&setup=true&lang=js"
export * from "./RcdView.vue?vue&type=script&setup=true&lang=js"

import "./RcdView.vue?vue&type=style&index=0&id=1e7adb84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7adb84"]])

export default __exports__